import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { moreResults } from '../data/testimonials';
export function MoreResults() {
  return <section className="border-t border-electric/10 bg-navy py-16 sm:py-20" aria-labelledby="results-title" data-id="element-103" data-mp="28eg99jwmki7p">
      <div className="mx-auto max-w-6xl px-4" data-id="element-104" data-mp="2d7ho5rwu0hra">
        <SectionHeading id="results-title" data-id="element-105" data-mp="2h7s49xec8ojv">What educators say</SectionHeading>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-106" data-mp="2h9w689sofdhi">
          {moreResults.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`flex flex-col rounded-2xl border border-electric/25 bg-panel p-6 shadow-lg shadow-black/30`} data-id="element-107" data-mp="2r5z9xk36fk6k" data-mpi={index}>
              <QuoteIcon className="h-6 w-6 text-gold" aria-hidden="true" data-id="element-108" data-mp="3nehgy6debcym" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-ink" data-id="element-109" data-mp="3im7lkatihkoy">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-electric/15 pt-4" data-id="element-110" data-mp="3dn39ncf7d8ux">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-electric/40 bg-navy text-sm font-extrabold text-electric" data-id="element-111" data-mp="38p1swy591lmm">
                  {initials}
                </span>
                <span data-id="element-112" data-mp="58urkyab40h0">
                  <b className="block text-sm text-white" data-id="element-113" data-mp="58mcr0umil36">{name}</b>
                  <small className="text-xs text-ink" data-id="element-114" data-mp="7owitt6c14b">{place}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}